// Helper function to parse E.164 phone number to antd-phone-input format
export const parseE164ToPhoneInputFormat = (e164Number) => {
  if (!e164Number || !e164Number.startsWith('+')) {
    return null;
  }

  // For Australian numbers (+61412345678)
  if (e164Number.startsWith('+61')) {
    const phoneNumber = e164Number.substring(3); // Remove +61
    return {
      countryCode: 61,
      areaCode: phoneNumber.substring(0, 1), // First digit after country code
      phoneNumber: phoneNumber.substring(1), // Rest of the number
      isoCode: "au"
    };
  }

  // For US numbers (+1234567890)
  if (e164Number.startsWith('+1')) {
    const phoneNumber = e164Number.substring(2); // Remove +1
    return {
      countryCode: 1,
      areaCode: phoneNumber.substring(0, 3), // First 3 digits
      phoneNumber: phoneNumber.substring(3), // Rest of the number
      isoCode: "us"
    };
  }

  // Add more country parsing as needed
  return null;
};

// Helper function to convert antd-phone-input object to E.164 format
export const convertPhoneInputToE164 = (phoneInputValue) => {
  if (!phoneInputValue || typeof phoneInputValue !== 'object') {
    return null;
  }

  const { countryCode, areaCode, phoneNumber } = phoneInputValue;
  
  if (!countryCode || !phoneNumber) {
    return null;
  }

  return `+${countryCode}${areaCode || ''}${phoneNumber}`;
};

// Phone number validator function
export const phoneValidator = (_, value) => {
  // Allow empty values (optional field)
  if (!value || (value?.phoneNumber === null && value?.areaCode === null)) {
    return Promise.resolve();
  }
  
  // Check if value has the valid function and use it
  if (value && typeof value.valid === 'function') {
    if (value.valid(true)) {
      return Promise.resolve();
    } else {
      return Promise.reject("Invalid phone number");
    }
  }
  
  // If no valid function, assume it's valid
  return Promise.resolve();
};
